import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { jwtSchema } from '../../../schemas/jwt.schema';
import { authwsEnvironment } from '../authws-environment';
import { fromFetch } from 'rxjs/fetch';

/**
 * Gerenate common JWT for given authentication pattern
 * @param token authenticationToken
 * @returns Common JWT
 */
export function postToken(
  this: unknown,
  token: { authenticationToken: string } | { refreshToken: string }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).identityTokenUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify(token),
    })
  ).pipe(selectData(jwtSchema));
}
